import { api } from "./api";

function encodePart(value) {
    return encodeURIComponent(String(value || "").trim());
}

function cleanParams(params = {}) {
    const out = {};

    for (const [key, value] of Object.entries(params)) {
        if (value == null || value === "") continue;
        out[key] = value;
    }

    return out;
}

export async function compileCustomContract(payload) {
    const res = await api.post("/custom-contracts/compile", payload);
    return res.data;
}

export async function getCustomVersion({ projectId, customVersionId }) {
    const res = await api.get(
        `/custom-contracts/versions/${encodePart(projectId)}/${encodePart(
            customVersionId,
        )}`,
    );

    return res.data;
}

export async function prepareCustomDeployment(payload) {
    const res = await api.post("/custom-contracts/deploy/prepare", payload, {
        timeout: 60000,
    });

    return res.data;
}

export async function preflightCustomDeployment(payload) {
  const res = await api.post("/custom-contracts/deploy/preflight", payload);
  return res.data;
}

export async function confirmCustomDeployment(payload) {
    const res = await api.post("/custom-contracts/deploy/confirm", payload, {
        timeout: 180000,
    });

    return res.data;
}

export async function requestCustomVerification(payload) {
    const res = await api.post("/custom-contracts/verify/request", payload, {
        validateStatus: () => true,
    });

    return res.data;
}

export async function checkCustomVerificationStatus(payload) {
    const res = await api.post("/custom-contracts/verify/status", payload, {
        validateStatus: () => true,
    });

    return res.data;
}

export async function listCustomDeployments(params = {}) {
    const res = await api.get("/custom-contracts/deployments", {
        params: cleanParams(params),
    });

    return res.data;
}

export async function getCustomDeployment(deploymentFile) {
    const res = await api.get(
        `/custom-contracts/deployments/${encodePart(deploymentFile)}`,
    );

    return res.data;
}

export async function prepareCustomAction(payload) {
    const res = await api.post("/custom-contracts/actions/prepare", payload, {
        timeout: 60000,
    });

    return res.data;
}

export async function confirmCustomAction(payload) {
    const res = await api.post("/custom-contracts/actions/confirm", payload, {
        timeout: 180000,
    });

    return res.data;
}

export async function listCustomActionHistory(params = {}) {
    const res = await api.get("/custom-contracts/actions/history", {
        params: cleanParams(params),
    });

    return res.data;
}

export async function readCustomContract(payload) {
    const res = await api.post("/custom-contracts/read", payload);
    return res.data;
}

export async function downloadCustomDeploymentFile({
    deploymentFile,
    type,
}) {
    const safeFile = encodePart(deploymentFile);

    const typePath = {
        abi: "abi",
        source: "source",
        standardInput: "standard-input",
        bundle: "bundle",
    }[type];

    if (!typePath) {
        throw new Error("Unsupported custom deployment download type.");
    }

    const res = await api.get(
        `/custom-contracts/deployments/${safeFile}/${typePath}`,
        {
            responseType: "blob",
        },
    );

    return res;
}

export async function downloadCustomVersionFile({
    projectId,
    customVersionId,
    type,
}) {
    const safeProject = encodePart(projectId);
    const safeVersion = encodePart(customVersionId);

    const typePath = {
        abi: "abi",
        source: "source",
        artifact: "artifact",
        standardInput: "standard-input",
    }[type];

    if (!typePath) {
        throw new Error("Unsupported custom version download type.");
    }

    const res = await api.get(
        `/custom-contracts/versions/${safeProject}/${safeVersion}/${typePath}`,
        {
            responseType: "blob",
        },
    );

    return res;
}

export function saveBlobResponse(response, fallbackFileName = "download") {
    const blob = response?.data;

    if (!blob) {
        throw new Error("Download response is empty.");
    }

    const disposition = response?.headers?.["content-disposition"] || "";
    const match = disposition.match(/filename="([^"]+)"/i);
    const fileName = match?.[1] || fallbackFileName;

    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement("a");

    anchor.href = url;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();

    window.URL.revokeObjectURL(url);
}

